import { Outlet } from 'react-router-dom';
import { WalletProvider } from '@/hooks/useWalletContext';

export function TokenizedLayout() {
  return (
    <WalletProvider>
      <Outlet />
    </WalletProvider>
  );
}
